import { RoutePath } from "#src/utils/route";
import { WorkersDefinitionsRoutePath } from "..";

/** Per-worker base path. Resolves to /workers/definitions/:workerId. */
export const WorkerRoutePath = WorkersDefinitionsRoutePath.concat(
  new RoutePath<"workerId">({
    path: "/:workerId",
    title: "Worker",
    isHidden: true,
  })
);
